<template>
    <v-expansion-panels class="acc-panels" flat accordion :value="value">
        <v-expansion-panel v-for="(section, index) in sections" :key="index" class="acc-item">
            <v-expansion-panel-header class="acc-header">
                <div class="acc-header-content">
                    <span class="acc-title">{{ section.title }}</span>
                    <v-icon v-if="isLocked(section)" size="14">mdi-lock-outline</v-icon>
                    <span v-if="section.count !== undefined" class="acc-count">({{ section.count }})</span>
                    <div v-if="$scopedSlots[`action-${section.value}`]" class="acc-action" @click.stop>
                        <slot :name="`action-${section.value}`" />
                    </div>
                </div>
                <template v-slot:actions>
                    <v-icon class="acc-chevron" size="18">mdi-chevron-down</v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="acc-content" :eager="eager">
                <slot :name="section.value" />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: "ExpandedSections",
    props: {
        sections: {
            type: Array,
            required: true
        },
        eager: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Number, Array],
            default: undefined
        }
    },
    methods: {
        isLocked(section) {
            return !!section.feature && !this.can(section.feature)
        },
    },
}
</script>

<style scoped>
.acc-panels {
    background: transparent;
}

.acc-item {
    background: var(--v-surface-base) !important;
    border-bottom: 1px solid var(--v-outline-base);
    border-radius: 0 !important;
}

.acc-item:last-child {
    border-bottom: none;
}

.acc-item::before {
    box-shadow: none !important;
}

.acc-panels >>> .acc-header {
    padding: 16px 20px;
    min-height: 0;
    transition: background 0.15s;
}

.acc-panels >>> .acc-header:hover {
    background: var(--v-surface2-base);
}

.acc-panels >>> .v-expansion-panel-header--active {
    background: rgba(204, 255, 51, 0.08);
    border-bottom: 1px solid rgba(204, 255, 51, 0.3);
}

.theme--light .acc-panels >>> .v-expansion-panel-header--active {
    background: rgba(204, 255, 51, 0.18);
}

.acc-header-content {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-width: 0;
    gap: 10px;
}

.acc-title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
}

.v-expansion-panel-header--active .acc-title {
    color: var(--v-txtPrimary-base);
}

.acc-count {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
}

.acc-action {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.acc-chevron {
    color: var(--v-txtMuted-base) !important;
}

.acc-panels >>> .acc-content .v-expansion-panel-content__wrap {
    padding: 8px 20px 12px;
}
</style>
